document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll('div[aria-labelledby="ResourceList0"] > div ul li > span');
    elements.forEach(function(element) {
        if (element.innerText.startsWith("Sale:")) {
            element.innerText = element.innerText.replace("Sale:", "Note:");
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
  const contentElements = document.querySelectorAll(".dynamic-content .content");
  contentElements.forEach(contentElement => {
    const buttonElement = contentElement.nextElementSibling;
    if (contentElement && buttonElement) {
      const originalText = contentElement.innerHTML;
      const truncatedText = originalText.slice(0, 100) + "..."; // Adjust the character limit

      let isExpanded = false;
      contentElement.innerHTML = truncatedText;

      buttonElement.addEventListener("click", function() {
        isExpanded = !isExpanded;
        contentElement.innerHTML = isExpanded ? originalText : truncatedText;
        buttonElement.innerText = isExpanded ? "Read Less" : "Read More";
      });
    }
  });
});

// $(document).ready(function () {
//   function AddReadMore() {
    
//     var carLmt = 300;
//     var readMoreTxt = " ...Read more";
//     var readLessTxt = " Read less";

//     //Traverse all selectors with this class and manupulate HTML part to show Read More
//     $(".add-read-more").each(function () {
//       if ($(this).find(".first-section").length) return;

//       var allstr = $(this).text();
//       if (allstr.length > carLmt) {
//         var firstSet = allstr.substring(0, carLmt);
//         var secdHalf = allstr.substring(carLmt, allstr.length);
//         var strtoadd =
//           firstSet +
//           "<span class='second-section'>" +
//           secdHalf +
//           "</span><span class='read-more'  title='Click to Show More'>" +
//           readMoreTxt +
//           "</span><span class='read-less' title='Click to Show Less'>" +
//           readLessTxt +
//           "</span>";
//         $(this).html(strtoadd);
//       }
//     });

//     //Read More and Read Less Click Event binding
//     $(document).on("click", ".read-more,.read-less", function () {
//       $(this)
//         .closest(".add-read-more")
//         .toggleClass("show-less-content show-more-content");
//     });
//   }

//   AddReadMore();
// });

// Og
// $(document).ready(function () {
//   function parseRichText(node) {
//     if (!node || !node.children) return '';

//     return node.children.map(child => {
//       if (child.type === 'text') {
//         return child.value;
//       } else if (child.type === 'link') {
//         const url = child.url || '#';
//         const target = child.target || '_self';
//         const linkContent = parseRichText(child);
//         return `<a href="${url}" target="${target}">${linkContent}</a>`;
//       } else if (child.type === 'paragraph') {
//         const paragraphContent = parseRichText(child);
//         return `${paragraphContent}`;
//       } else {
//         return '';
//       }
//     }).join('');
//   }

//   function AddReadMore() {
//     var carLmt = 300; 
//     var readMoreTxt = " ...Read more"; 
//     var readLessTxt = " Read less";

//     $(".add-read-more").each(function () {
//       if ($(this).find(".first-section").length) return;

//       var allstr = $(this).text();
//       if (allstr.length > carLmt) {
//         var firstSet = allstr.substring(0, carLmt);
//         var secdHalf = allstr.substring(carLmt, allstr.length);
//         var strtoadd =
//           firstSet +
//           "<span class='second-section'>" +
//           secdHalf +
//           "</span><span class='read-more' title='Click to Show More'>" +
//           readMoreTxt +
//           "</span><span class='read-less' title='Click to Show Less'>" +
//           readLessTxt +
//           "</span>";
//         $(this).html(strtoadd);
//       }
//     });

//     // Toggle between "Read More" and "Read Less"
//     $(document).on("click", ".read-more,.read-less", function () {
//       $(this)
//         .closest(".add-read-more")
//         .toggleClass("show-less-content show-more-content");
//     });
//   }

//   function renderDynamicContent() {
//     const collectionDescription = document.querySelector(".collection-description");

//     if (collectionDescription) {
//       const contentData = collectionDescription.getAttribute("data-content");
//       try {
//         const contentJson = JSON.parse(contentData);
//         const parsedContent = parseRichText(contentJson);
//         collectionDescription.innerHTML = `<div class="add-read-more show-less-content">${parsedContent}</div>`;
//         AddReadMore(); 
//       } catch (error) {
//         console.error("Error parsing JSON content: ", error);
//       }
//     }
//   }

//   renderDynamicContent(); // Render content and initialize "Read More/Read Less"
// });


$(document).ready(function () {
  function parseRichText(node) {
    if (!node || !node.children) return '';

    return node.children.map(child => {
      if (child.type === 'text') {
        return child.value;
      } else if (child.type === 'link') {
        const url = child.url || '#';
        const target = child.target || '_self';
        const linkContent = parseRichText(child);
        return `<a href="${url}" target="${target}">${linkContent}</a>`;
      } else if (child.type === 'paragraph') {
        const paragraphContent = parseRichText(child);
        return `${paragraphContent}`;
      } else {
        return '';
      }
    }).join('');
  }

  function addReadMore() {
    var wordLimit = 45; // Word limit for "Read More"
    var readMoreTxt = " ...Read more"; // Text when collapsed
    var readLessTxt = " Read less"; // Text when expanded

    $(".add-read-more").each(function () {
      if ($(this).find(".first-section").length) return;

      var allstr = $(this).html();
      var firstSet = "";
      var secdHalf = "";
      var wordCount = 0;

      // Split the content into words while keeping the HTML structure
      var words = allstr.split(/(\s+)/); // Split by whitespace while keeping spaces

      for (let i = 0; i < words.length; i++) {
        var word = words[i];
        firstSet += word;

        if (word.trim().length > 0) {
          wordCount++;
        }

        if (wordCount >= wordLimit) {
          secdHalf = words.slice(i + 1).join('');
          break;
        }
      }

      if (wordCount >= wordLimit) {
        var strtoadd =
          `<span class='first-section'>${firstSet}</span>` +
          `<span class='second-section' style='display:none;'>${secdHalf}</span>` +
          `<span class='read-more' title='Click to Show More'>${readMoreTxt}</span>` +
          `<span class='read-less' style='display:none;' title='Click to Show Less'>${readLessTxt}</span>`;
        $(this).html(strtoadd);
      }
    });

    // Toggle between "Read More" and "Read Less" smoothly
    $(document).on("click", ".read-more", function () {
      var $this = $(this);
      $this.siblings(".second-section").slideDown(300, function () {
        // After the animation is complete
        $this.hide(); // Hide the "Read More" button
        $this.siblings(".read-less").show(); // Show the "Read Less" button
      });
    });

    $(document).on("click", ".read-less", function () {
      var $this = $(this);
      $this.siblings(".second-section").slideUp(300, function () {
        // After the animation is complete
        $this.hide(); // Hide the "Read Less" button
        $this.siblings(".read-more").show(); // Show the "Read More" button
      });
    });
  }

  function renderDynamicContent() {
    const collectionDescription = document.querySelector(".collection-description");

    if (collectionDescription) {
      const contentData = collectionDescription.getAttribute("data-content");
      try {
        const contentJson = JSON.parse(contentData);
        const parsedContent = parseRichText(contentJson);
        collectionDescription.innerHTML = `<div class="add-read-more show-less-content">${parsedContent}</div>`;
        addReadMore(); // Apply "Read More/Read Less" after content is rendered
      } catch (error) {
        console.error("Error parsing JSON content: ", error);
      }
    }
  }

  renderDynamicContent(); // Render content and initialize "Read More/Read Less"
});


